import React, { Component } from "react";
import { DataGrid, GridToolbar } from '@material-ui/data-grid'
import Edit from '@material-ui/icons/Edit';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AddBoxIcon from '@mui/icons-material/AddBox';
import axios from 'axios';
import InputLabel from '@mui/material/InputLabel';
import { MenuItem, Select } from '@material-ui/core';
import { Backdrop, Button,  Checkbox,  CircularProgress,  FormControl, FormControlLabel, Grid, Hidden, ListItemButton } from "@mui/material";
import moment from 'moment';
import 'moment/locale/es';
import { TextField, Typography } from "@material-ui/core";

const url = "https://nrbegzvavi.execute-api.us-east-1.amazonaws.com/dev/history/find";
const urlById = "https://nrbegzvavi.execute-api.us-east-1.amazonaws.com/dev/history/find/id";
   
const isTherapy = (type) => {
    return (type == "Fisioterapia" || type == "Fonoaudiologia" 
             || type == "Terapia ocupacional" || type == "Psicología"
             || type == "SST OCUPACIONAL")
  }
 
  

class FindHistories extends Component {

   

    state = {
        data:[],
        openLoader: false,
        myHistories: true,
        patientId: "",
        specialisyId: "0",
        aditionalInfo: [{ 
            generalities: {externalCause: 'OTRA', reason: '', illness: '',},
            plan: {
                  descriptions: '',
                  observations: ''
                },
              
            assessmentDate: new Date(),
            procedures: [],
            diagnoses: [],
            referrals: [],
            treatments: []
            }]
    }

    handleChange = e => {
		this.setState({patientId: e.target.value})
       
	}

     handleChangeSpecialist = e => {
        this.setState({specialisyId: e.target.value})
    }

    activeMyHistories = e => {
        //console.log(" my e.target.checked " + e.target.checked);
        this.setState({myHistories: e.target.checked});
        //this.setState({openLoader: true});
     //   this.peticionGet(e.target.checked);
      }
  
      peticionGet = (myHistories) => {
        let history = {id:'', patientId: ''};
       
      
       // console.log(" my Histories " + myHistories +  " " +this.state.patientId);
        if(this.state.patientId != "") {
         //   console.log("Deberia ingresar ");
            history.patientId = this.state.patientId;
        } else  if(this.props.user.rol == 'medico' && this.state.myHistories) {
            history.id = this.props.user.id;
        }

        if (history.id == "" && history.patientId == "") {
            this.setState({openLoader: false});
            return
        }
        
       // console.log("medical ID " +  this.state.myHistories + " " + history.patientId + " id " + history.id)
        //console.log(" my Histories " + myHistories);
        axios.post(url, history).then(response => { 
            if(response.data) {
               // response.data.filter(this.state.specialisyId)
            //   console.log("data type>>> " +response.data[0].medicalTeam.id + " espec " +  this.state.specialisyId);
            if (this.state.specialisyId != "0") {
              //  console.log("filtra especialidad type>>> " );
               response.data = response.data.filter(data =>  data.type == this.state.specialisyId)
              
            }
          
          
            if (this.props.user.rol == 'medico' && this.state.myHistories) {
              //  console.log("filtra por medico type>>> " );
                response.data = response.data.filter(data =>  data.medicalTeam?.id == this.props.user.id) 
            }
                //originInfo[props.indexEvolution].diagnoses
               // .filter(diagnose => diagnose.classDiagnosis == "Diagnostico Principal").map( (item, index) => {
             // diagnoses.push([index + 1, item.id, item.description, item.classDiagnosis ])
          //}
                this.setState({data: response.data});
            } else {
                this.setState({data: []});
            }
          
          this.setState({openLoader: false});
         
        }); 
    };

    peticionFindById = (history, action) => {
        axios.post(urlById, history).then(response => { 
           
           let indexMenu = 8;
            
        // console.log("se envia " + JSON.stringify(response.data));
          switch(action) {
              case 1:
                if(response.data.type == "Nutricionista") {
                    indexMenu = 17
                    this.props.setIndexEvolution(0);
                    break;
                }
                if (response.data.evolutions.length -1 >= 0) {
                    let evolution = JSON.parse(JSON.stringify(response.data.evolutions[response.data.evolutions.length -1]));
                    evolution.id = null;
                    evolution.assessmentDate = new Date();
                    if(!isTherapy(response.data.type) && (response.data.type != "Enfermeria")
                    && (response.data.type != "Trabajadora Social") &&
                    (response.data.type != "Nutricionista")  ) {
                        evolution.useBarthel = Number(evolution.barthel?.score) != -1;
                    }
                    response.data.evolutions = response.data.evolutions.concat(evolution);
                
                }
                
              {
                if(isTherapy(response.data.type)) {
                    indexMenu = 7
                } else if(response.data.type == "Enfermeria") {
                    indexMenu = 14
                } else if(response.data.type == "Trabajadora Social") {
                    indexMenu = 15
                }else if(response.data.type == "Nutricionista") {
                    indexMenu = 17
                }else if(response.data.type == "Medicina Laboral") {
                    indexMenu = 18
                } else {
                 indexMenu = 6; 
                }
              }
              this.props.setIndexEvolution(response.data.evolutions.length -1);
              break;
              case 2:
                indexMenu = 8; 
                this.props.setIndexEvolution(response.data.evolutions.length -1);
                break;
                case 3:
                    if(response.data.additionalsInfo == null) {
                        response.data.additionalsInfo = [];
                    }
                     
                    response.data.additionalsInfo  = response.data.additionalsInfo.concat(this.state.aditionalInfo);
                   // console.log("Aditional Info " + JSON.stringify(response.data.additionalsInfo));
                    indexMenu = 16; 
                    this.props.setIndexEvolution(response.data.additionalsInfo.length -1);
                break;
          }
          this.props.setAffiliate(response.data)
         
          this.props.changeMenu(indexMenu) 
          this.setState({openLoader: false});
         
        }); 
    };

    componentDidMount() {
        this.setState({openLoader: true});
        this.peticionGet(true);
    }

    render() {
        
      const columns = [
        { field: 'createDate', headerName: 'Fecha', width: 140, valueGetter: (params) =>
        `${moment(params.row.createDate).locale('es').format('MMMM D YYYY')}` },
        { field: 'id', headerName: 'Cedula', width: 140, valueGetter: (params) =>
            `${params.row.patient.id}` },
            { field: 'lastName', headerName: 'Apellidos', width: 150, valueGetter: (params) =>
            `${params.row.patient.lastName || ''} ${params.row.patient.secondLastName || ''}`, },
            //{ field: 'lastName', headerName: 'Last name', width: 150 },
            
            {
                field: 'fullName',
                headerName: 'Nombres',
                description: 'Nombre Completo.',
                sortable: false,
                width: 160,
                valueGetter: (params) =>
                  `${params.row.patient.firstName || ''} ${params.row.patient.secondName || ''}`,
              },
              { field: 'type', headerName: 'Especialidad', width: 140 },
            { field:'editar', headerName: 'Evolucionar',  width: 140, align: 'center', headerAlign: 'center', sortable: false, renderCell: (params) => {
                return (
                    <div>
                        <ListItemButton onClick={() => {
                            
                            this.setState({openLoader: true});
                            this.peticionFindById(params.row, 1);
                            
                        }}>
                        <Edit />
                        </ListItemButton>
                    </div>
                );
            } },
            {
                field: 'fullNameMedical',
                headerName: 'Medico',
                description: 'Medico.',
                sortable: false,
                width: 160,
                valueGetter: (params) =>
                  `${params.row.medicalTeam.firstName || ''} ${params.row.medicalTeam.lastName || ''}`,
              },
            
            /*{ field:'see_PDF', headerName: 'Ver Historia', align: 'center', width: 140, headerAlign: 'center', sortable: false, renderCell: (params) => {
                return (
                    <div>
                        <ListItemButton onClick={() => {
                            this.setState({openLoader: true});
                            this.peticionFindById(params.row, 2);
                            
                        }}>
                        <PictureAsPdfIcon />
                        </ListItemButton>
                    </div>
                );
            } },*/
            { field:'add_aux_history', headerName: 'Historia Adicional', align: 'center', width: 140, headerAlign: 'center', sortable: false, renderCell: (params) => {
                return (
                    <div>
                        <ListItemButton onClick={() => {
                            this.setState({openLoader: true});
                            this.peticionFindById(params.row, 3);
                        }}>
                         <AddBoxIcon/>
                        </ListItemButton>
                    </div>
                );
            } }/*,
            { field:'Change_Medical', headerName: 'Cambiar Medico', align: 'center', width: 140, headerAlign: 'center', sortable: false, renderCell: (params) => {
                return (
                  
                    <div>
                    <ListItemButton onClick={() => {
                        
                        this.setState({openLoader: true});
                        this.peticionFindById(params.row, 1);
                        
                    }}>
                    <Edit />
                    </ListItemButton>
                </div>
                );
            } }*/
            /* <Hidden xsUp={!(this.props.user.rol == 'medico') }>
                          <FormControlLabel  label="Solo Mis Historias"  control={
                            <Checkbox 
                                name="myHistories"
                                id='myHistories'
                                checked={this.state.myHistories}
                                onChange={this.activeMyHistories}
                            />
                            } />
                        </Hidden>*/ 
        ];

        return (
            <div style={{ height: 700, width: '100%' }}>
                    <FormControl>
                        <Button variant="contained"  color="primary" onClick={() => {
                            this.props.setReturnPageId(5);
                            this.props.setComeFromMenu(false);
                            this.props.changeMenu(3);
                        }}>
                            Nueva Historia
                        </Button> 
                      
                      
                        <Grid container spacing={2}  >
                        <Grid item xs={12} sm={12} md={12} > 
                          <FormControlLabel  label="Solo Mis Historias"  control={
                            <Checkbox 
                                name="myHistories"
                                id='myHistories'
                                checked={this.state.myHistories}
                                onChange={this.activeMyHistories}
                            />
                            } />
                       
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} > 
                             <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Cedula Paciente</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} > 
                            <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Especializacion</Typography>
                        </Grid>
                         <Grid item xs={12} sm={6} md={6} > 
                            <TextField
                                id='patientId'
                                name='patientId'
                                value={this.state.patientId}
                                onChange={this.handleChange}
                                variant='outlined'
                                aria-label="minimum height"
                                placeholder="cedula del paciente a buscar"
                                fullWidth />
                         </Grid>
   
                      
    <Grid item xs={12} sm={6} md={6} >
                            <div>
                            <InputLabel id="typeLabel"></InputLabel>
                                <Select
                                    labelId="typeLabel"
                                    id="type"
                                    name="type"
                                    value={this.state.specialisyId}
                                    onChange={this.handleChangeSpecialist}
                                    label="Especializacion">
                                    <MenuItem value={"0"}>
                                        <em>Cualquiera especialidad</em>
                                    </MenuItem>
                                    <MenuItem value={"Medicina General"}>1. Medicina General</MenuItem>
                                    <MenuItem value={"Medicina Interna"}>2. Medicina Interna</MenuItem>
                                    <MenuItem value={"Ginecologia y obstetricia"}>3. Ginecologia y obstetricia</MenuItem>
                                    <MenuItem value={"Pediatria"}>4. Pediatria</MenuItem>
                                    <MenuItem value={"Fisiatria"}>5. Fisiatria</MenuItem>
                                    <MenuItem value={"Cardiologia"}>6. Cardiologia</MenuItem>
                                    <MenuItem value={"Fisioterapia"}>7. Fisioterapia</MenuItem>
                                    <MenuItem value={"Fonoaudiologia"}>8. Fonoaudiologia</MenuItem>
                                    <MenuItem value={"Terapia ocupacional"}>9. Terapia ocupacional</MenuItem>
                                    <MenuItem value={"Medicina especializada"}>10. Medicina especializada</MenuItem>
                                    <MenuItem value={"Psicología"}>11. Psicología</MenuItem>
                                    <MenuItem value={"Enfermeria"}>12. Enfermeria</MenuItem>
                                    <MenuItem value={"Trabajadora Social"}>13. Trabajadora Social</MenuItem>
                                    <MenuItem value={"Nutricionista"}>14. Nutricionista</MenuItem>
                                    <MenuItem value={"Medicina Laboral"}>15. Medicina Laboral</MenuItem>
                                    <MenuItem value={"SST OCUPACIONAL"}>16. SST OCUPACIONAL</MenuItem>
                                    <MenuItem value={"Neurología"}>17. Neurología</MenuItem>
                                                                                                   
                                </Select>
                            </div>
                       
                    </Grid>
<Grid item xs={12} sm={6} md={6} > 
<Button 
                           // type="submit" 
                            variant="contained" 
                            color="primary" 
                            display="inline" 
                            onClick={() => {
                                this.setState({openLoader: true});
                                this.peticionGet(false);
                            }}>
                                Buscar
                            </Button>
                            </Grid>
                            </Grid>
                    </FormControl>
                   
              <DataGrid
                rows={this.state.data}
                columns={columns}
                pagination
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowCount={600}
                checkboxSelection={true}
                
                componentsProps={{
                    columnMenu: { background: 'red', counter: this.state.data.length },
                  }}
                  components={{
                    Toolbar: GridToolbar,
                  }}
              />

        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={this.state.openLoader}>
            <CircularProgress color="inherit" />
        </Backdrop>
      </div>
          )
    }
}

export default FindHistories;
